<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Hasil Edops'">
          <template v-slot:toolbar>
            <buttonPrint/>
          </template>
          <template v-slot:body>
            <div class="pt-2 mb-6">
              <cardKriteriaPenilaian />
            </div>

            <!--begin::Body-->
            <template v-for="(item, i) in list">
              <!--begin::Item-->
              <div class="align-items-center mb-10" v-bind:key="i">
                <v-alert
                  border="left"
                  colored-border
                  color="deep-purple accent-4"
                  elevation="2"
                >
                  <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-40 symbol-light-success mr-10">
                      <span class="symbol-label">
                        <v-avatar>
                          <img :src="item.img" alt="Image" />
                        </v-avatar>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!-- name -->
                    <div class="d-flex align-items-center flex-grow-1">
                      <span class="font-weight-bold">
                        {{ item.name }}
                      </span>
                    </div>
                    <!-- name end -->
                    <!--begin::Text-->
                    <div class="d-flex flex-column flex-grow-1 font-weight-bold">
                      <span class="font-weight-bold">
                        {{ item.title }}
                      </span>
                      <span class="font-weight-bold">
                        {{ item.desc }}
                      </span>
                    </div>
                    <!--end::Text-->
                    <!--begin::Text-->
                    <div class="d-flex flex-column flex-grow-1 font-weight-bold">
                      <span class="font-weight-bold">
                        {{ item.pertemuan }}
                      </span>
                      <span class="font-weight-bold">
                        {{ item.desc }}
                      </span>
                    </div>
                    <!--end::Text-->
                    <!--begin::Button-->
                    <router-link to="/edops/staff/hasil-edops/edops-result/edops-result-detail" custom v-slot="{ navigate }">
                      <v-btn @click="navigate" role="link" style="background-color: #ffff; height: 30px; width: 30px; min-width: 30px; border-radius: 10px;" size="sm">
                        <b-icon icon="chevron-right" scale="2"></b-icon>
                      </v-btn>
                    </router-link>
                    <!--end::Button-->
                  </div>
                </v-alert>
              </div>
              <!--end::Item-->
            </template>
          </template>
        </KTCodePreview>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import buttonPrint from "@/view/content/components/button/buttonPrint.vue";
import cardKriteriaPenilaian from "@/view/content/components/card/KriteriaPenilaian.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";


export default {
  data() {
    return {
      list: [
        {
          name: "Andi Perdana Cahyadi",
          title: "Nilai Total",
          pertemuan: "Pertemuan 1",
          desc: "100.00",
          img: "media/users/100_4.jpg",
          style: "svg-icon-primary"
        },
        {
          name: "Fauzan Adzim",
          title: "Nilai Total",
          pertemuan: "Pertemuan 1",
          desc: "100.00",
          img: "media/users/100_4.jpg",
          style: "svg-icon-warning"
        },
        {
          name: "Nama Andi",
          title: "Nilai Total",
          pertemuan: "Pertemuan 1",
          desc: "100.00",
          img: "media/users/100_4.jpg",
          style: "svg-icon-success"
        },
        {
          name: "Ricky Hunt",
          title: "Nilai Total",
          pertemuan: "Pertemuan 1",
          desc: "100.00",
          img: "media/users/100_4.jpg",
          style: "svg-icon-danger"
        },
        {
          name: "Carles Puyol",
          title: "Nilai Total",
          pertemuan: "Pertemuan 1",
          desc: "100.00",
          img: "media/users/100_4.jpg",
          style: "svg-icon-info"
        }
      ],
      hasil: {
        search: "",
        headers: [
          { text: "No", value: "no" },
          { text: "Dosen", value: "dosen" },
          { text: "Mata Pelajaran", value: "mataKuliah" },
          { text: "Nilai Total", value: "nilaiTotal" },
          { text: "Nilai Akhir", value: "nilaiAkhir" },
          { text: "Pertemuan", value: "pertemuan" },
          { text: "Aksi", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            dosen: "Hanif Nurcholis",
            mataKuliah: "Statistik",
            nilaiTotal: 0,
            nilaiAkhir: 1,
            pertemuan: "2x",
          },
          {
            no: 2,
            dosen: "Hanif Nurcholis",
            mataKuliah: "Statistik",
            nilaiTotal: 0,
            nilaiAkhir: 1,
            pertemuan: "2x",
          },
          {
            no: 3,
            dosen: "Hanif Nurcholis",
            mataKuliah: "Statistik",
            nilaiTotal: 0,
            nilaiAkhir: 2,
            pertemuan: "1x",
          },
          {
            no: 4,
            dosen: "Hanif Nurcholis",
            mataKuliah: "Statistik",
            nilaiTotal: 0,
            nilaiAkhir: 5,
            pertemuan: "2x",
          },
          {
            no: 5,
            dosen: "Hanif Nurcholis",
            mataKuliah: "Statistik",
            nilaiTotal: 0,
            nilaiAkhir: 1,
            pertemuan: "3x",
          }
        ]
      }
    };
  },
  components: {
    KTCodePreview,
    buttonPrint,
    cardKriteriaPenilaian
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "EDOPS" },
      { title: "Master EDOPS Staff" },
    ]);
  }
}

</script>